import React from 'react';
import { navigate } from '@gatsbyjs/reach-router/';
import { useGlobal, globalizationPath } from '@rcg/ui-react';
import Button from '../UiComponents/Button';
import { ReactComponent as WarningIcon } from '../../assets/svg/warning_outlined.svg';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';
import { setSessionStorageItem } from '../../operations/sessionStorage/utils';
import { trackInteraction } from '../../utils/analytics/bookFlightsTracking';
import {
  NAVIGATION_PATHS,
  SESSION_STORAGE_CHANGE_FLIGHTS,
  SESSION_STORAGE_NAVIGATION_HISTORY_LAST_ENTRY,
} from '../../utils/constants';

import useStyles from './index.style';

const MissingFlights = () => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);
  const {
    data: { lang, market },
  } = useGlobal();

  const urlPath = globalizationPath(market, lang, NAVIGATION_PATHS.base);

  const goToDeparture = () => {
    const dataLayer = {
      eventType: 'interaction',
      interaction: 'air:bookAdditional:clicked',
    };
    trackInteraction(dataLayer);
    setSessionStorageItem(SESSION_STORAGE_CHANGE_FLIGHTS, false);
    setSessionStorageItem(SESSION_STORAGE_NAVIGATION_HISTORY_LAST_ENTRY, window.location.href);
    navigate(`${urlPath}${NAVIGATION_PATHS.resultsDeparture}`);
  };

  return (
    <>
      <div className={classes.missingFlights}>
        <div className="left-content">
          <WarningIcon />
          <span>{getDictionary(Dictionary.airMissingFlightsLabel.key)}</span>
        </div>
        <Button color="primary" variant="outlined" onClick={goToDeparture}>
          {getDictionary(Dictionary.airMissingFlightsCTA.key)}
        </Button>
      </div>
    </>
  );
};

export default MissingFlights;
